import styled from "styled-components";

import Button from "./Button";

import PlayerOrder from "./PlayerOrder";
import Checkbox from "./Checkbox";
import GameRule from "./Types/GameRule";
import Game from "./Types/Game";
import RadioButton from "./RadioButton";
import HardTooltip from "./Tooltips/HardTooltip";
import BombTooltip from "./Tooltips/BombTooltip";
import NormalTooltip from "./Tooltips/NormalTooltip";
import InsaneTooltip from "./Tooltips/InsaneTooltip";
interface Props {
  game: Game;
  name: string;
  onLeave: (game: Game, name: string) => void;
  onStart: (game: Game) => void;
  onGameRulesChange: (game: Game, rules: GameRule) => void;
  onTimeLimitChange: (game: Game, isTimeLimitEnabled: boolean) => void;
}

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledGameLobby = styled.div`
  font-size: 2rem;
  text-align: center;
  padding: 2em;
`;

const StyledPlayerOrder = styled(PlayerOrder)`
  position: relative;
  text-align: center;
  display: inline-block;
  min-width: 350px;

  > div {
    align-items: center;
    justify-content: center;

    &:before {
      display: none;
    }
  }
`;

const GameLobby = ({
  game,
  name,
  onLeave,
  onStart,
  onGameRulesChange,
  onTimeLimitChange,
}: Props) => {
  let gameRule = game.rules;
  let isTimeLimitEnabled = game.isTimeLimitEnabled;

  return (
    <StyledGameLobby>
      <Button
        isDark
        style={{ position: "absolute", right: "20px", bottom: "20px" }}
        onClick={() => onLeave(game, name)}
      >
        leave game session
      </Button>
      <h1>Hello and welcome to the lobby of game {game.friendlyId}.</h1>
      <br></br>
      <h2>Registered players:</h2>
      <StyledPlayerOrder players={game.players} />
      <br />
      <br />

      <FlexContainer>
        <RadioButton
          label="Normal mode"
          isSelected={gameRule === GameRule.Normal}
          onChange={() => onGameRulesChange(game, GameRule.Normal)}
        />
        <NormalTooltip />
      </FlexContainer>
      <FlexContainer>
        <RadioButton
          label="Bomb mode"
          isSelected={gameRule === GameRule.Bomb}
          onChange={() => onGameRulesChange(game, GameRule.Bomb)}
        />
        <BombTooltip />
      </FlexContainer>
      <FlexContainer>
        <RadioButton
          label="Hard mode"
          isSelected={gameRule === GameRule.Hard}
          onChange={() => onGameRulesChange(game, GameRule.Hard)}
        />
        <HardTooltip />
      </FlexContainer>
      <FlexContainer>
        <RadioButton
          label="Insane mode"
          isSelected={gameRule === GameRule.Insane}
          onChange={() => onGameRulesChange(game, GameRule.Insane)}
        />
        <InsaneTooltip />
      </FlexContainer>
      <Checkbox
        label="Play with time limit (30 seconds)"
        isSelected={isTimeLimitEnabled}
        onCheckboxChange={(isChecked: boolean) =>
          onTimeLimitChange(game, isChecked)
        }
      />
      <br />
      <br />
      <Button onClick={() => onStart(game)}>start game</Button>
    </StyledGameLobby>
  );
};

export default GameLobby;
